import cartSagas from '../../core/js/sagas/cartSagas';
import userSagas from '../../core/js/sagas/userSagas';
import utagSagas from '../../core/js/sagas/utagSagas';
import groundhogSagas from '../../core/js/sagas/groundhogSagas';
import initialSagas from '../../core/js/sagas/initialSagas';
import helpSagas from './sagas/sagas';
import favoritesSagas from '../../core/js/sagas/favoritesSagas';
import { getSaytSagas } from '../../core/js/sagas/saytSagas';
import { getGridFavoritesSagas } from '../../core/js/sagas/gridFavoritesSagas';
import { init as coreInit } from '../../core/js/components/coreComponent';
import { init as helpInit } from './components/helpComponent';
import { helpStyleFetcher } from './utils/gridUtils';
import { configureStore } from './store';

const sagas = [
    ...initialSagas,
    ...cartSagas,
    ...getSaytSagas(),
    ...userSagas,
    ...utagSagas,
    ...groundhogSagas,
    ...helpSagas,
    ...favoritesSagas,
    ...getGridFavoritesSagas(helpStyleFetcher)
];

const store = configureStore();

sagas.forEach((saga) => {
    store.runSaga(saga);
});

const helpRegistry = helpInit(store);
const coreRegistry = coreInit(store);

window.__store = store;
